import {Injectable} from '@angular/core';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FinancialYearService {

  constructor() { }
  getCurrentFinancialYear():any {
   const today = new Date();
   const year = today.getFullYear();

   let startDate = new Date();
   let endDate = new Date();

   if(today.getMonth() >= 5){ // June (index 5) onward
     startDate = new Date(year, 3, 1); // April 1st of the current year
     endDate = new Date(year + 1, 2, 31, 23, 59, 59, 999); // March 31st of the next year (end of day)
   }else { // before June 1st, still counted as the previous financial year
     startDate = new Date(year - 1, 3, 1); // April 1st of the previous year
     endDate = new Date(year, 2, 31, 23, 59, 59, 999); // March 31st of the current year (end of day)
   }
   return {
     startDate,
     endDate
   }
  }
  isCurrentFinancialYear(date: Date): boolean {
    const fy = this.getCurrentFinancialYear();

    return date >= fy.startDate && date <= fy.endDate;
  }
}
